import {firestore} from '@enigma/core/services';
import React, { useEffect, useState } from 'react';
import Button from '../../../../elements/Button/Button';
import Input from '../../../../elements/Input/Input';
import { ico_check, ico_play, ico_times, 
    ico_trash, ico_angle_down, ico_bolt } from '../../../../icon';
import Stylesheet from './Query.module.css';
import Classnames from 'classnames';
import Filter from '../Filter/Filter';

const Query = (props) => {
    const metadata = props.metadata;
    const table = props.table;
    const app = props.app;
    const query = props.query;
    const [isActive, setIsActive] = useState(query.report.report?.id === metadata.id);
    const [active, setActive] = useState(false);
    useEffect(() => {
        let passed = true;
        // check if the basic requirments of the query is met
        if (!metadata.title || !metadata.description) passed = false;
        if (!metadata?.filters) passed = false;
        else {
            // check if any filters have missing values
            for (let index = 0; index < metadata.filters.length; index++) {
                const filter = metadata.filters[index];
                if (!filter.column) passed = false;
                if (!filter.operator && index > 0) passed = false;
                if (!filter.operation) passed = false;
                if (!filter.value || filter.value === "") passed = false;
            }
        }
        if (metadata.isNew && passed) {
            // query passed validation
            update({...metadata, isNew: false});
        }
        if (!metadata.isNew && !passed) {
            // query passed validation
            update({...metadata, isNew: true});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])
    // add new filter to query
    const add = _ => {
        firestore.collection(
        `${table.metadata.document}/queries`)
        .doc(`${metadata.id}`)
        .update({
            filters: firestore.fieldValue.arrayUnion({
                operator: null,
                column: null,
                operation: null,
                value: null
            })
        }).then(_ => 
        app.toggleToast(ico_check, 'new filter successfully added'))
    }
    // update query
    const update = (newMetadata) => {
        firestore.collection(
        `${table.metadata.document}/queries`)
        .doc(`${metadata.id}`)
        .update(newMetadata).then(_ => 
            app.toggleToast(ico_check, 'query updated'))
    }
    // remove query
    const remove = async _ => {
        const response = await app.toggleMessageBox('confirm query deletion', 
        'Are you sure you want to remove the query ?. This can not be undone.', "yes_no");
        if (response === "yes") {
            firestore.collection(
            `${table.metadata.document}/queries`)
            .doc(`${metadata.id}`)
            .delete().then(_ => 
                app.toggleToast(ico_check, 'query successfully removed'));
        }
    }
    /**
     * Extract record value and identify value to perform query on
     */
    const getCellValue = (cell, column) => {
        const schemas = [...table.schema, 
            {name: 'branch', title: 'branch', type: 'branch'}, 
            {name: 'author', title: 'author', type: 'author'},
            {name: 'timestamp', title: 'date added', type: 'timestamp'}];
        const schema = schemas.find(({name}) => name === column);
        // identify column type
        let value = cell;
        if (schema.type === "file" && cell?.name)
            value = cell.name;
        return value;
    }
    /**
     * Perform filter operation verification on record cell value.
     */
    const exeOperation = (cell, filterValue, operation) => {
        // validate operations
        switch (operation) {
            case "GREATER THEN":
                return cell > parseInt(filterValue);
            case "LESS THEN":
                return cell < parseInt(filterValue);
            case "LIKE":
            case "NAME LIKE":
                return `${cell}`.toLowerCase().replaceAll(/[\\() ]/g, "")
                .search(`${filterValue}`.toLowerCase().replaceAll(/[\\() ]/g, "")) > -1;
            case "SIZE GREATER THEN":
                // TO DO
                break;
            case "SIZE LESS THEN":
                // TO DO
                break;
            // EQUALS by default
            default:
                return cell === filterValue;
        }
    }
    /**
     * Execute operator validation on record value
     */
    const exeOperator = (operator, prevPass, currentPass) => {
        // identify filter operator
        switch (operator) {
            case "OR":
                return prevPass || currentPass;
            case "NOT":
                return prevPass && !currentPass;
            // AND by default
            default:
                return prevPass && currentPass;
        }
    }
    /**
     * Identify if filter operation is a group operation,
     * which is ment to be executed after the filtering
     */
    const isGroupOperation = (operation) => {
        switch (operation) {
            case "GROUP BY":
            case "AVERAGE":
            case "SUM":
            case "AVERAGE DAYS":
            case "SUM DAYS":
                return true;
            default:
                return false;
        }
    }
    /**
     * Execute Group By operations
     */
    const execGroupBy = (groupFilters, report) => {
        // primary grouping column
        // the first filter is always the primary group filter
        const groupColumn = groupFilters[0];
        // grouping results
        const resultRecords = [...report.records]
        .sort((a,b) => {
            if (typeof a[groupColumn.column] === "string")
                return a[groupColumn.column].length - b[groupColumn.column].length;
            else if (typeof a[groupColumn.column] === "object")
                return a[groupColumn.column].name - b[groupColumn.column].name;
            else 
                return a[groupColumn.column] - b[groupColumn.column];
        });
        console.log(resultRecords);
        // render results and enable data visuals
        query.setReport({report: report.report, records: resultRecords});
    }
    /**
     * Executive selected query
     */
    const execute = _ => {
        const report = {report: null, records: []}
        if (isActive) {
            // close query
            query.setReport(report);
            setIsActive(false);
            // notify query termination
            app.toggleToast(ico_bolt, 'query terminated successfully');
        } else {
            report.report = metadata;
            let collection = [];
            let groupFilters = [];
            // identify group filters
            for (const filter of metadata.filters)
                if (isGroupOperation(filter.operation))
                    groupFilters.push(filter);
            // identify matching records
            for (const record of table.records) {
                // identify if record has passed the filter
                let passed = false;
                // identifies indexes of non-group filters
                let actualIndex = 0;
                // cycle though each filter
                for (let index = 0; index < metadata.filters.length; index++) {
                    // current filter
                    const filter = metadata.filters[index];
                    // ignore group operations
                    if (isGroupOperation(filter.operation)) continue;
                    // current record cell value
                    const recordsCell = record[filter.column];
                    // ignore records that have null values for selected filter column
                    if (recordsCell && recordsCell !== "NULL") {
                        // identify cell value
                        const cell = getCellValue(recordsCell, filter.column);
                        // validate operations
                        const currentPass = 
                        exeOperation(cell, filter.value, filter.operation);
                        // validate  operator, initial filters do not have operators
                        passed = actualIndex === 0 
                        ? currentPass 
                        : exeOperator(filter.operator, passed, currentPass);
                    }
                    actualIndex++;
                }
                if (passed || metadata.filters.length === 1) collection.push(record);
            }
            report.records = collection;
            // execute group filters (if any)
            if (metadata.isGroup) execGroupBy(groupFilters, report);
            else query.setReport(report);
            setIsActive(true);
            // notify query termination
            app.toggleToast(ico_bolt, 'query successfully executed');
        }
    }
    /**
     * Render query filters
     */
    const filters = _ => {
        if (!active) return null;
        let collection = [];
        for (let index = 0; index < metadata?.filters?.length || 0; index++) {
            const filter = metadata.filters[index];
            collection.push(
                <Filter 
                key={index}
                index={index}
                metadata={filter} 
                table={table} 
                query={metadata} 
                app={app} />
            )
        }
        return (
            <div className={Stylesheet.Configuration}>
                {collection.map((value, index) => (value))}
                <div className={Stylesheet.AddFilter}>
                    <Button secondary
                    onClick={add}>add new filter</Button>
                </div>
            </div>
        )
    }

    return (
        <div className={Classnames(Stylesheet.Container,{
            [Stylesheet['Pending']]: metadata.isNew,
            [Stylesheet['Active']]: active
        })}>
            <div className={Stylesheet.Header}>
                <div className={Stylesheet.Execute}>
                    <Button icon minimal 
                    disabled={metadata.isNew} onClick={execute}>
                    {isActive ? ico_times : ico_play}</Button>
                </div>
                <div className={Stylesheet.Metadata}>
                    <Input placeholder='query title' 
                    defaultValue={metadata.title} 
                    onBlur={value => value !== metadata.title 
                        && update({...metadata, title: value})} />
                    <Input placeholder='query description'
                    defaultValue={metadata.description} 
                    onBlur={value => value !== metadata.description 
                        && update({...metadata, description: value})} />
                </div>
                <div className={Stylesheet.Controls}>
                    <Button icon minimal onClick={remove}>
                    {ico_trash}</Button>
                    <Button icon minimal 
                    onClick={_ => setActive(active ? false : true)}>
                    {ico_angle_down}</Button>
                </div>
            </div>
            {filters()}
        </div>
    )
}

export default Query;